// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home__pricing {
  position: relative;
  padding: 4rem 0;
  width: 100vw;
}
.home__pricing .img_container {
  position: absolute;
  z-index: 0;
  opacity: 0.2;
  top: 100px;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  width: 100vw;
  height: 680px;
}
.home__pricing .img_container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.home__pricing .home_pricing_content {
  width: 100vw;
  height: 700px;
}
.home__pricing .home_pricing_content h2 {
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
}
.home__pricing .home_pricing_content h2 span {
  color: #e63b11;
}
.home__pricing .home_pricing_content .pricing-swiper {
  padding-bottom: 40px;
  height: 500px;
  margin: 0 10%;
}
.home__pricing .home_pricing_content .pricing-swiper .pricing_card {
  background: white;
  padding: 2% 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.home__pricing .home_pricing_content .pricing-swiper .pricing_card .img_icon {
  height: 60px;
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.home__pricing .home_pricing_content .pricing-swiper .pricing_card .multi_icons {
  display: flex;
  justify-content: center;
  gap: 15%;
  width: 100%;
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.home__pricing .home_pricing_content .pricing-swiper .pricing_card .multi_icons .card_icon {
  font-size: 3rem;
  color: #e63b11;
  margin-top: 1rem;
}
.home__pricing .home_pricing_content .pricing-swiper .pricing_card .multi_icons .img_icon {
  height: 50px;
}
.home__pricing .home_pricing_content .pricing-swiper .pricing_card h2 {
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  color: #333;
  padding: 0 2%;
}
.home__pricing .home_pricing_content .pricing-swiper .pricing_card .card__text {
  margin-bottom: 1.5rem;
}
.home__pricing .home_pricing_content .pricing-swiper .pricing_card .card__text strong {
  display: block;
  margin-bottom: 0.8rem;
  font-size: 1.1rem;
  color: #555;
}
.home__pricing .home_pricing_content .pricing-swiper .pricing_card .card__text strong span {
  color: #e63b11;
  float: right;
}
.home__pricing .home_pricing_content .pricing-swiper .pricing_card .line_small {
  border-bottom: 2px solid #e63b11;
  margin-bottom: 1.5rem;
  align-self: flex-start;
}
.home__pricing .home_pricing_content .pricing-swiper .pricing_card .line_big {
  margin-bottom: 0.5rem;
  margin-top: 1.5rem;
  border-bottom: 2px solid #e63b11;
  align-self: flex-start;
}
.home__pricing .home_pricing_content .pricing-swiper .pricing_card .line_big {
  width: 30%;
}
.home__pricing .home_pricing_content .pricing-swiper .pricing_card .line_small {
  width: 20%;
}
.home__pricing .home_pricing_content .pricing-swiper .pricing_card em {
  font-size: 1rem;
  margin-top: auto;
  color: #555;
  font-style: normal;
  width: 80%;
  margin-bottom: 3%;
}
.home__pricing .home_pricing_content .pricing-swiper .pricing_card em strong {
  color: #e63b11;
}
.home__pricing .home_pricing_content .pricing-swiper .swiper-pagination {
  bottom: 0;
}
.home__pricing .home_pricing_content .pricing-swiper .swiper-pagination-bullet {
  background: #ccc;
  opacity: 1;
  width: 12px;
  height: 12px;
}
.home__pricing .home_pricing_content .pricing-swiper .swiper-pagination-bullet-active {
  background: #e63b11;
}

@media (max-width: 690px) {
  .home__pricing {
    padding: 3rem 0;
  }
  .home__pricing .home_pricing_content h2 {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
  .home__pricing .home_pricing_content .pricing-swiper {
    width: 80vw;
  }
  .home__pricing .home_pricing_content .pricing-swiper .pricing_card {
    width: 80vw;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 15% 0;
  }
  .home__pricing .home_pricing_content .pricing-swiper .pricing_card .img_icon {
    height: 50px;
  }
  .home__pricing .home_pricing_content .pricing-swiper .pricing_card .multi_icons .card_icon {
    font-size: 2.5rem;
  }
  .home__pricing .home_pricing_content .pricing-swiper .pricing_card .multi_icons .img_icon {
    height: 40px;
  }
  .home__pricing .home_pricing_content .pricing-swiper .pricing_card h2 {
    font-size: 1.5rem;
  }
  .home__pricing .home_pricing_content .pricing-swiper .pricing_card .card__text strong {
    font-size: 1rem;
  }
  .home__pricing .home_pricing_content .pricing-swiper .pricing_card em {
    font-size: 0.85rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Pricing.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,eAAA;EACA,YAAA;AADF;AAME;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;AAJN;AAOI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AALR;AAQE;EACM,YAAA;EACJ,aAAA;AANJ;AAUI;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;AARN;AAUM;EACE,cAAA;AARR;AAYI;EACE,oBAAA;EACA,aAAA;EACA,aAAA;AAVN;AAaM;EACE,iBAAA;EAEA,aAAA;EACA,yCAAA;EAEA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAbR;AAeQ;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;AAbV;AAgBQ;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAdV;AAgBU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAdZ;AAiBU;EACE,YAAA;AAfZ;AAmBQ;EACE,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;AAjBV;AAoBQ;EAEE,qBAAA;AAnBV;AAqBU;EACE,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,WAAA;AAnBZ;AAqBY;EACE,cAAA;EACA,YAAA;AAnBd;AAuBQ;EACI,gCAAA;EACA,qBAAA;EACA,sBAAA;AArBZ;AAuBQ;EACI,qBAAA;EACA,kBAAA;EACA,gCAAA;EACF,sBAAA;AArBV;AAwBQ;EAAY,UAAA;AArBpB;AAsBQ;EAAc,UAAA;AAnBtB;AAqBQ;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;AAnBV;AAqBU;EACE,cAAA;AAnBZ;AAwBM;EACE,SAAA;AAtBR;AAwBQ;EACE,gBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AAtBV;AAwBU;EACE,mBAAA;AAtBZ;;AA+BA;EACE;IACE,eAAA;EA5BF;EA+BI;IACE,eAAA;IACA,mBAAA;EA7BN;EAgCI;IAEE,WAAA;EA/BN;EAiCM;IAEA,WAAA;IACA,sBAAA;IC7IJ,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;ID4II,cAAA;EA7BN;EA+BQ;IACE,YAAA;EA7BV;EAiCU;IACE,iBAAA;EA/BZ;EAkCU;IACE,YAAA;EAhCZ;EAoCQ;IACE,iBAAA;EAlCV;EAqCQ;IACE,eAAA;EAnCV;EAsCQ;IACE,kBAAA;EApCV;AACF","sourcesContent":["@import \"./variables.scss\";\n\n.home__pricing {\n  position: relative;\n  padding: 4rem 0;\n  width: 100vw;\n  //   background: #f9f9f9;\n  \n  \n  \n  .img_container {\n      position: absolute;\n      z-index: 0;\n      opacity: 0.2;\n      top: 100px;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      pointer-events: none; // Allows clicks to pass through to content below\n      width: 100vw;\n      height:680px;\n\n    \n    img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n  }\n  .home_pricing_content {\n        width: 100vw;\n    height: 700px;\n    // margin: 0 5;\n    // padding: 0 5%;\n\n    h2 {\n      font-size: 2.5rem;\n      text-align: center;\n      margin-bottom: 3rem;\n      \n      span {\n        color: #e63b11;\n      }\n    }\n\n    .pricing-swiper {\n      padding-bottom: 40px;\n      height:500px;\n      margin:0 10%;\n    //   border: 1px solid black;\n\n      .pricing_card {\n        background: white;\n        // border-radius: 10px;\n        padding: 2% 0;\n        box-shadow: 0 4px 15px rgba(0,0,0,0.1);\n        // max-height: 650px;\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n\n        .img_icon {\n          height: 60px;\n          margin-bottom: 1rem;\n          margin-top: 1rem;\n        }\n\n        .multi_icons {\n          display: flex;\n          justify-content: center;\n          gap: 15%;\n          width: 100%;\n          margin-bottom: 1rem;\n          margin-top: 1rem;\n\n          .card_icon {\n            font-size: 3rem;\n            color: #e63b11;\n            margin-top: 1rem;\n          }\n\n          .img_icon {\n            height: 50px;\n          }\n        }\n\n        h2 {\n          font-size: 1.8rem;\n          margin-bottom: 1.5rem;\n          text-transform: uppercase;\n          color: #333;\n          padding: 0 2%;\n        }\n\n        .card__text {\n        //   width: 100%;\n          margin-bottom: 1.5rem;\n\n          strong {\n            display: block;\n            margin-bottom: 0.8rem;\n            font-size: 1.1rem;\n            color: #555;\n\n            span {\n              color: #e63b11;\n              float: right;\n            }\n          }\n        }\n        .line_small {\n            border-bottom: 2px solid #e63b11;\n            margin-bottom: 1.5rem;\n            align-self: flex-start;\n        }\n        .line_big {\n            margin-bottom: 0.5rem;\n            margin-top: 1.5rem;\n            border-bottom: 2px solid #e63b11;\n          align-self: flex-start;\n        }\n\n        .line_big { width: 30%; }\n        .line_small { width: 20%; }\n\n        em {\n          font-size: 1.0rem;\n          margin-top: auto;\n          color: #555;\n          font-style: normal;\n          width:80%;\n          margin-bottom: 3%;\n\n          strong {\n            color: #e63b11;\n          }\n        }\n      }\n\n      .swiper-pagination {\n        bottom: 0;\n        \n        &-bullet {\n          background: #ccc;\n          opacity: 1;\n          width: 12px;\n          height: 12px;\n          \n          &-active {\n            background: #e63b11;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 690px) {\n  .home__pricing {\n    padding: 3rem 0;\n    \n    .home_pricing_content {\n      h2 {\n        font-size: 2rem;\n        margin-bottom: 2rem;\n      }\n\n      .pricing-swiper {\n        // width:100%;\n        width:80vw;\n        // margin :10%;\n        .pricing_card {\n        //   padding: 1.5rem;\n        width:80vw;\n        background-color: #fff;\n        @include columnStack;\n        padding: 15% 0;\n          \n          .img_icon {\n            height: 50px;\n          }\n          \n          .multi_icons {\n            .card_icon {\n              font-size: 2.5rem;\n            }\n            \n            .img_icon {\n              height: 40px;\n            }\n          }\n          \n          h2 {\n            font-size: 1.5rem;\n          }\n\n          .card__text strong {\n            font-size: 1rem;\n          }\n          \n          em {\n            font-size: 0.85rem;\n          }\n        }\n      }\n    }\n  }\n}\n\n// @media (min-width: 691px) and (max-width: 992px) {\n//   .home__pricing {\n//     .home_pricing_content {\n//       .pricing-swiper {\n//         .pricing_card {\n//             background-color: #fff;\n//             @include columnStack;\n//             padding: 2% 0;\n          \n//           h2 {\n//             font-size: 1.6rem;\n//           }\n          \n//           .card__text strong {\n//             font-size: 1rem;\n//           }\n//         }\n//       }\n//     }\n//   }\n// }\n\n// @media (min-width: 1200px) {\n//   .home__pricing {\n//     // padding: 5rem 0;\n//   }\n// }","//colours\n$orange: #e63b11;\n$font: #000;\n$lightGrey: #d1d3d4;\n$darkGrey: #939598;\n$darkBlue: #01426a;\n$lightBlue: #77c5d5;\n\n//mobile breaks\n$mobilemin:100;\n$mobile: 690px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1000px;\n$landsTabletMin2: 1000px;\n$landsTabletMax2: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@mixin columnStart{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin columnStartCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin columnStack{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin rowEven{\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowEvenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n\n@mixin rowBetween{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin button {\n        background-color: $orange;\n        color: #fff;\n        text-transform: uppercase;\n        border: none;\n        // height: 3rem;\n        border-radius: 1.5rem;\n        letter-spacing: 0.1rem;\n        font-weight: 600;\n        // margin: 3% auto;\n        transition: background-color 0.3s ease;\n        padding: 0 2rem;\n        cursor: pointer;\n        \n        &:hover {\n          background-color: #000;\n        }\n      \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
